var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.679 30C110.378 16.6667 129.622 16.6667 137.321 30L206.603 150C214.301 163.333 204.678 180 189.282 180H50.718C35.322 180 25.6995 163.333 33.3975 150L102.679 30Z",
    fill: "#FDDC2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.738 117.213V50.9093H130.97V117.213H115.738ZM115.738 143.069V127.837H130.97V143.069H115.738Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon-warning.4094818cf66e60149ccaa6adce510b4e.svg";
export { ForwardRef as ReactComponent };